import { render, staticRenderFns } from "./EditTextureVk.vue?vue&type=template&id=4b623315&scoped=true"
import script from "./EditTextureVk.vue?vue&type=script&lang=js"
export * from "./EditTextureVk.vue?vue&type=script&lang=js"
import style0 from "./EditTextureVk.vue?vue&type=style&index=0&id=4b623315&prod&lang=scss"
import style1 from "./EditTextureVk.vue?vue&type=style&index=1&id=4b623315&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b623315",
  null
  
)

export default component.exports